/* eslint-disable */
import React, { Component } from 'react';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import { Redirect } from 'react-router';
import GoogleLogin from 'react-google-login';
import ReactTooltip from 'react-tooltip';
import FacebookLogin from 'react-facebook-login';

import axios from 'axios';
import Aux from './../../hoc/Aux';
import Classes from './LoginScreen.css';
import logger from './../../logger';
import config from './../../moramma-config.json';
import lang from './../../lang.json';


class LoginScreen extends Component{ 

    state = {
        txtEmailValue : '',
        redirect: false,
        showEmailSent: false,
        redirectRegisterPage: false,
        redirectRegisterPageName: '',
        redirectRegisterPageSurname: '',
        redirectRegisterPageEmail: '',
        language: 'IT-it',
        expandOtherAuthenticationMethod: false,
    };

    responseGoogle = (response) => {
        if(!response.profileObj) {
            return;
        }
        if(response.profileObj.email) {
            axios({
                method: 'post',
                url: `${config['BASE_API']}/auth/o-auth-passwordless`,
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                data: {user_mail: response.profileObj.email}
              }).then(items => {
             //   console.log(response.profileObj);
                if(items.data.code === 200) {
                    // save API JWT on localstorage
                    localStorage.setItem('API', items.data.data.owner.api_token);
                    this.setState({redirect:true});
                }
              }).catch( err => {
                // redirect to register page
                this.setState({redirectRegisterPage:true, redirectRegisterPageEmail: response.profileObj.email, redirectRegisterPageName : response.profileObj.givenName, redirectRegisterPageSurname: response.profileObj.familyName });
              });
        } else {
            ToastsStore.warning('Oops. Something goes wrong.');
        }
      }

      changeLanguage = () => {
          if(this.state.language === 'IT-it') {
            this.setState({ language: 'EN-en' });
          } else {
            this.setState({ language: 'IT-it' });
          }
      }

    sendEmail = () => {
        const RE_MAIL = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i);
        if(RE_MAIL.test(this.state.txtEmailValue)) {
            logger.debug('[LoginScreen|sendEmail] Submit email button clicked');
            fetch(`${config['BASE_API']}/auth/auth-passwordless`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_mail: this.state.txtEmailValue
                })
            })
            .then((response) => {
                return response.json();
            })
            .then( (data) => {
                if(data.code === 500) {
                    ToastsStore.error("No account was found with that email. Maybe you want to register?");
                }     
                else if(data.code === 200){
                    this.setState({showEmailSent: true});
                }
            });
            
        }
        else {
            logger.debug('[LoginScreen|sendEmail] INVALID EMAIL. Submit email button clicked');
            ToastsStore.error("Invalid email! Make sure is correct.");
        }
        
    };
    
    handleChange = (event) => {
        this.setState({txtEmailValue: event.target.value});
    };

    btnGoogleLoginHandler = (event) => {
        logger.debug('[LoginScreen|btnGoogleLoginHandler] google login button clicked');
    }

    expand = () => {
        this.setState({ expandOtherAuthenticationMethod: !this.state.expandOtherAuthenticationMethod });
    }

    componentDidMount = () => {
        const localtoken = localStorage.getItem('API');
        if  (localtoken) {
            console.log('si local token');
            this.setState({redirect:true});
            return;
        }
        console.log('no local token');
        const query = new URLSearchParams(this.props.location.search);
        const user = query.get('user');
        const token = query.get('magiclink');

       // console.log(user,token);
        
        if(user && token) {
            fetch(`${config['BASE_API']}/react/auth-passwordless-verify`, {
                method: 'POST',
                headers: {
                    "Authorization" : `Bearer ${token}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_mail: user,
                    token: token
                })
            })
            .then((response) => {
                return response.json();
            })
            .then( (payload) => {
                if(payload) {
                    if(payload.code === 500 || payload.code === 402) {   
                        ToastsStore.error("Login fallito");
                        localStorage.clear();
                    }
                    else if(payload.code === 200) {

                        // save API JWT on localstorage
                        localStorage.setItem('API', payload.data.owner.api_token);
                        this.setState({redirect:true});
                    }     
                }
                else {
                    ToastsStore.error("Login fallito");
                    localStorage.clear();
                }
            });   
        } 
        console.log('no user token');

    }

    handleLoginEnterKey = (e) => {
        if (e.key === 'Enter') {
            this.sendEmail();
        }
    }

      responseFacebook = (response) => {
        if(response.email) {
            axios({
                method: 'post',
                url: `${config['BASE_API']}/auth/o-auth-passwordless`,
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                data: {user_mail: response.email}
              }).then(items => {
             //   console.log(response.profileObj);
                if(items.data.code === 200) {
                    // save API JWT on localstorage
                    localStorage.setItem('API', items.data.data.owner.api_token);
                    this.setState({redirect:true});
                }
              }).catch( err => {
                // redirect to register page
                this.setState({redirectRegisterPage:true, redirectRegisterPageEmail: response.email, redirectRegisterPageName : response.name.split(' ')[0], redirectRegisterPageSurname: response.name.split(' ')[1] });
              });
        } else {
            ToastsStore.warning('Oops. Something goes wrong with facebok login.');
        }
      }

    /**
     * ============================================================================
     *                              RENDER PAGE
     * ============================================================================
     */
    render() {
        document.body.style.overflow = "auto";

        if(this.state.redirect === true) {
            document.body.style.overflow = "auto";
            return <Redirect to='/mg-screen' />
            
        }
        if(this.state.redirectRegisterPage === true) {
            document.body.style.overflow = "auto";
            return <Redirect to={`/register?name=${this.state.redirectRegisterPageName}&surname=${this.state.redirectRegisterPageSurname}&email=${this.state.redirectRegisterPageEmail}`} />
        }

        if(this.state.showEmailSent === true) {
            return (
                <Aux>
                    <div className="container-fluid">
                        <br />
                        <br />
                        <div className="row">
                        <div className="col" />
                        <div className={`col-3 ${Classes.TxtCenter}`}>
                            <div className={` ${Classes.CardLogin}`}>
                                <br />
                                <br />
                                <img src={require('./../../assets/img/moramma-logo.png')} style={{height: 100}} />
                                <br />
                                <br />
                                <h5>Magic link inviato!</h5>
                                <img src={(require('./../../assets/svg/emailSent.svg'))} className={`img-fluid ${Classes.ImgMail}`} alt="phone" title="phone" />
                                <br/>
                                <p>Accesso veloce?</p>
                                <button className={Classes.CustomLoginButton} type="button"> <a href="https://mail.google.com/mail/u/0/" target="_blank"> <i className="fas fa-envelope-open-text"> </i> Apri Gmail</a></button>
                                <br/>
                                <br/>
                            </div>
                            <br/>
                        </div>
                        <div className="col" />
                        <div className={`col-6 ${Classes.TxtCenter}`}>
                                <h3 className="animated fadeInUp">{lang[this.state.language].loginscreen_slogan_1of2}<br />{lang[this.state.language].loginscreen_slogan_2of2}</h3>
                                <br/>
                                <br/>
                                <img ClassName="animated fadeInUp" src={require('./../../assets/svg/phone.svg')} />
                        </div>
                        </div>
                    </div>
                    <ReactTooltip />
                    <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
                </Aux>
            );
        }

        return (
            <Aux>
                {
                    !this.state.expandOtherAuthenticationMethod ? (
                        <div className="container-fluid">
                        <br />
                        <br />
                        <div className="row">
                        <div className="col" />
                        <div className={`col-4 ${Classes.TxtCenter}`} style={{maxWidth: 450}}>
                            <div className={` ${Classes.CardLogin}`}>
                                <br />
                                <br />
                                <img src={require('./../../assets/img/moramma-logo.png')} style={{height: 100}} />
                                <br />
                                <br />
                                <h4 className={`animated fadeIn ${Classes.Cardtitle}`}>{lang[this.state.language].loginscreen_welcome}</h4>
                                <br />
                                <p className="animated fadeIn">{lang[this.state.language].loginscreen_welcome_description_p1of2}<br />{lang[this.state.language].loginscreen_welcome_description_p2of2}</p>
                                <br/>
                                
                                <GoogleLogin
                                    clientId="796838889485-dddj2316svgpmotc39vvl1ptj206utbe.apps.googleusercontent.com"
                                    render={renderProps => (
                                        <button className={Classes.CustomLoginButton} onClick={renderProps.onClick} disabled={renderProps.disabled} type="button"><i className="fab fa-google"></i> Sign in with Google</button>
                                    )}
                                    buttonText="Login"
                                    onSuccess={this.responseGoogle}
                                    onFailure={this.responseGoogle}
                                    cookiePolicy={'single_host_origin'}
                                />
                                <br/>
                                <br/>
                                {/** FOR HTTPS https://stackoverflow.com/questions/35565278/ssl-localhost-privacy-error/41020281 */}
                                <FacebookLogin
                                    appId="153946918704154"
                                    autoLoad={false}
                                    fields="name,email,picture"
                                    cssClass={Classes.CustomLoginButton}
                                    callback={this.responseFacebook} />
                               
                                <br/>
                                <br/>
                                <br/>
                                <a className={Classes.Link} href="#" onClick={this.expand} ><p className="animated fadeIn">{lang[this.state.language].loginscreen_login_ptitle}</p></a>
                               
                                </div>
                                <br/>
                                <p><a className={Classes.Link} href="/register">{lang[this.state.language].loginscreen_create_account}</a>  | <a className={Classes.Link}  target="_blank" href="https://moramma.com/it-privacy-policy.html">Privacy</a> | <i onClick={this.changeLanguage} data-html="true" data-place="right" data-tip="Change language <br /> Cambia lingua" className={`fas fa-flag ${Classes.HelpIcon}`} /></p>
                            </div>
                            <div className="col" />
                            <div className={`col-4 ${Classes.TxtCenter} d-flex flex-column align-self-center justify-content-end`}>
                                    <h2 className={`animated fadeInUp ${Classes.RightDescription}`}>{lang[this.state.language].loginscreen_slogan_1of2}<br />{lang[this.state.language].loginscreen_slogan_2of2}</h2>
                                    <br/>
                                    <img ClassName="animated fadeInUp img-fluid" src={require('./../../assets/svg/phone.svg')} style={{maxHeight: 200}} />
                                    <br/>
                                    <p className={`animated fadeInUp ${Classes.ToRight}`}>{lang[this.state.language].loginscreen_slogan_descr}</p>
                            </div>
                            <div className="col" />
                            </div>
                            <ReactTooltip />
                        </div>
                    ) : (
                        <div className="container-fluid">
                        <br />
                        <br />
                        <div className="row">
                        <div className="col" />
                        <div className={`col-4 ${Classes.TxtCenter}`} style={{maxWidth: 450}}>
                            <div className={` ${Classes.CardLogin}`}>
                                <br />
                                <br />
                                <img src={require('./../../assets/img/moramma-logo.png')} style={{height: 100}} />
                                <br />
                                <br />
                                <h4 className={`animated fadeIn ${Classes.Cardtitle}`}>{lang[this.state.language].loginscreen_welcome}</h4>
                                <br />
                                <p className="animated fadeIn">{lang[this.state.language].loginscreen_welcome_description_p1of2}<br />{lang[this.state.language].loginscreen_welcome_description_p2of2}</p>
                                <br/>
                                
                                <GoogleLogin
                                    clientId="796838889485-dddj2316svgpmotc39vvl1ptj206utbe.apps.googleusercontent.com"
                                    render={renderProps => (
                                        <button className={Classes.CustomLoginButton} onClick={renderProps.onClick} disabled={renderProps.disabled} type="button"><i className="fab fa-google"></i> Sign in with Google</button>
                                    )}
                                    buttonText="Login"
                                    onSuccess={this.responseGoogle}
                                    onFailure={this.responseGoogle}
                                    cookiePolicy={'single_host_origin'}
                                />
                            <br/>
                                <br/>
                                {/** FOR HTTPS https://stackoverflow.com/questions/35565278/ssl-localhost-privacy-error/41020281 */}
                                <FacebookLogin
                                    appId="153946918704154"
                                    autoLoad={false}
                                    fields="name,email,picture"
                                    cssClass={Classes.CustomLoginButton}
                                    callback={this.responseFacebook} />
                            <br/>
                                <br/>
                                <br/>
                                <a className={Classes.Link} href="#" onClick={this.expand} ><p className="animated fadeIn">{lang[this.state.language].loginscreen_login_ptitle}  <i data-html="true" data-place="right" data-tip={lang[this.state.language].loginscreen_welcome_description_1of2 + "\n" + lang[this.state.language].loginscreen_welcome_description_2of2} className={`far fa-question-circle ${Classes.HelpIcon}`} /></p> </a>
                               
                                <br/>
                                <input className={Classes.InputMail} onChange={this.handleChange} onKeyPress={this.handleLoginEnterKey} type="text" placeholder="E-mail" />
                                <ReactTooltip />
                                <br/>
                                <br/>
                                {
                                    this.state.txtEmailValue === '' ? (
                                        ''
                                    ) : (
                                        <button className={`${Classes.LoginButton} animated fadeInUp`} onClick={this.sendEmail} type="button"> Login </button>
                                    )
                                }     
                                </div>
                                <br/>
                                <p><a className={Classes.Link} href="/register">{lang[this.state.language].loginscreen_create_account}</a>  | <a className={Classes.Link}  target="_blank" href="https://moramma.com/it-privacy-policy.html">Privacy</a> | <i onClick={this.changeLanguage} data-html="true" data-place="right" data-tip="Change language <br /> Cambia lingua" className={`fas fa-flag ${Classes.HelpIcon}`} /></p>
                            </div>
                            <div className="col" />
                            <div className={`col-4 ${Classes.TxtCenter} d-flex flex-column align-self-center justify-content-end`}>
                                    <h2 className={`animated fadeInUp ${Classes.RightDescription}`}>{lang[this.state.language].loginscreen_slogan_1of2}<br />{lang[this.state.language].loginscreen_slogan_2of2}</h2>
                                    <br/>
                                    <img ClassName="animated fadeInUp img-fluid" src={require('./../../assets/svg/phone.svg')} style={{maxHeight: 200}} />
                                    <br/>
                                    <p className={`animated fadeInUp ${Classes.ToRight}`}>{lang[this.state.language].loginscreen_slogan_descr}</p>
                            </div>
                            <div className="col" />
                            </div>
                            <ReactTooltip />
                        </div>
                    )
                }
                <ReactTooltip />
                <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>  
            </Aux>
        );
    }
}

export default LoginScreen;